import { fromUnixTime } from 'date-fns';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import useTranslation from '../../../../../hooks/useTranslations';
import { UploadIcon, CheckmarkFilledIcon, DocumentIcon, TrashIcon } from '../../../../misc/icons/Icons';
import { backupEvaluations, openEvaluationDeleteModal, selectEvaluationIsBackedUp } from '../../../../../redux/modules/evaluationsSlice';
import useFormatLocaleDate from '../../../../../hooks/useFormatLocaleDate';

const EvaluationRow = ({ evaluation }) => {
	const t = useTranslation();
	const dispatch = useDispatch();

	const evaluationIsBackedUp = useSelector((state) => selectEvaluationIsBackedUp(state, evaluation.id));

	const {
		id, title, businessAreaId, evalAppCategoryTranslationKey, updatedAt, finalized,
	} = evaluation;

	const openDeleteModal = () => {
		dispatch(openEvaluationDeleteModal({ evaluationId: id }));
	};

	return (
		<div className="relative flex items-center justify-between w-full h-34 can-hover:hover:bg-gray-50">
			<NavLink
				to={`/${businessAreaId}/evaluations/${id}`}
				className="flex flex-col items-start justify-center flex-grow h-full gap-3 pl-4 sm:pl-10 pr-36 sm:pr-56 focus:outline-none"
			>
				<span className="font-semibold text-[1.0625rem] py-2 line-clamp-2">
					{title}
				</span>
				<span className="text-[0.75rem] sm:text-[0.9375rem] text-oly-gray-dark line-clamp-2">
					{useFormatLocaleDate(fromUnixTime(updatedAt))}
					{' '}
					•
					{' '}
					{t(evalAppCategoryTranslationKey)}
				</span>
			</NavLink>
			<div className="absolute right-0 flex flex-shrink-0 pr-3 sm:gap-6">
				<>
					{finalized && <CheckmarkFilledIcon className="self-center w-5 h-5 mx-3 sm:mx-4 sm:w-6 sm:h-6 text-oly-yellow-default" />}
					{evaluationIsBackedUp && (
						<a
							href={process.env.REACT_APP_API_BASE_URL + process.env.REACT_APP_API_PATH_EVAL_APP_DOC + id}
							className="flex items-center flex-shrink-0 p-2 rounded-lg text-oly-yellow-default can-hover:hover:shadow-button focus-visible:shadow-button focus:outline-none"
							aria-labelledby={t('webapp_pdf_doc')}
							title={t('webapp_pdf_doc')}
							target="_blank"
							rel="noreferrer"
						>
							<DocumentIcon className="w-6 h-6 sm:w-8 sm:h-8" />
						</a>
					)}
					{finalized && !evaluationIsBackedUp && (
						<button
							type="button"
							onClick={() => dispatch(backupEvaluations())}
							className="flex items-center flex-shrink-0 p-2 rounded-lg text-oly-red-default can-hover:hover:shadow-button focus-visible:shadow-button focus:outline-none"
							aria-labelledby={t('webapp_upload')}
							title={t('webapp_upload')}
						>
							<UploadIcon className="w-6 h-6 sm:w-8 sm:h-8" />
						</button>
					)}
					<button
						type="button"
						onClick={() => openDeleteModal()}
						className="flex items-center flex-shrink-0 p-2 rounded-lg text-oly-yellow-default can-hover:hover:shadow-button focus-visible:shadow-button focus:outline-none"
						aria-labelledby={t('multisend_send_mail_closed_alert_remove')}
						title={t('multisend_send_mail_closed_alert_remove')}
					>
						<TrashIcon className="w-6 h-6 sm:w-8 sm:h-8" />
					</button>
				</>
			</div>
		</div>
	);
};

export default EvaluationRow;
